<template>
  <v-select style="font-size:13px;" v-bind="$attrs" v-on="$listeners" box single-line dense hide-details></v-select>
</template>

<script>
export default {

}
</script>
